import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GlobalService } from './global.service';
import { LogService } from './log.service';
import { Dupe } from '../models/dupe.model';

@Injectable({ providedIn: 'root' })
export class DupesService {
  apiHost: string = environment.apiHost;

  constructor(
    private http: HttpClient,
    private globalService: GlobalService,
    private logService: LogService
  ) {}

  getDupes(userId: string) {
    let promise = new Promise<Dupe[]>((resolve, reject) => {
      return this.http
        .get<Dupe[]>(this.apiHost + '/Member/GetDupes?UserId=' + userId)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Permission', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  resolveDupe(sourceId: number, destinationId: number) {
    let promise = new Promise((resolve, reject) => {
      return this.http
        .post(
          this.apiHost +
            '/Member/ResolveDupe?SourceId=' +
            sourceId +
            '&DestinationId=' +
            destinationId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Permission', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  markAsDifferent(sourceId: number, destinationId: number) {
    let promise = new Promise((resolve, reject) => {
      return this.http
        .post(
          this.apiHost +
            '/Member/MarkAsDifferent?SourceId=' +
            sourceId +
            '&DestinationId=' +
            destinationId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Permission', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }
}
